export default __webpack_public_path__ + "static/media/nodejs-logo.398b584e.svg";